export default {
    API: '/process/', // note the trailing slash (otherwise the POST request to /process will get a 301 (Location: /process/) and that means a second request will start but that will be a GET request instead of a POST request (we would need HTTP Code 307))

    ROUTES: {
        HOME: '/',
        ABOUT: '/about',
        NEWS: '/news',
        PROJECTS: '/projects',
        CONTACT: '/contact',
        FAQ: '/faq',
        IMPRINT: '/imprint',
        SITEMAP: '/sitemap',
    },

    TITLE_DEFAULT: 'WikINM',
    TITLE_SUFFIX: ' - WikINM',
};